module.exports = __webpack_public_path__ + "static/media/19.d3b63d7a.mp3";